module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/verve-e70b81ab0fd4d2d8bf1cb9e287d2fbd2.svg";